export default "__VITE_ASSET__CV75vVCb__"